import { render, staticRenderFns } from "./RetailerLogosGridSection.vue?vue&type=template&id=649a0c2f&scoped=true&"
import script from "./RetailerLogosGridSection.vue?vue&type=script&lang=js&"
export * from "./RetailerLogosGridSection.vue?vue&type=script&lang=js&"
import style0 from "./RetailerLogosGridSection.vue?vue&type=style&index=0&id=649a0c2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a0c2f",
  null
  
)

export default component.exports